import { autoinject } from 'aurelia-framework';
import { AuthHttpClient } from './auth-http-client';
import { BaseApiService } from './base-api-service';
import { Models } from 'models/core';
import { QueryFilter } from 'lib/tables/DataFilter';

@autoinject
export class ConsumptionMaterialWashingService extends BaseApiService<Models.ConsumptionMaterialWashing> {
  constructor(httpClient: AuthHttpClient) {
    super(httpClient, Models.ConsumptionMaterialWashing);
  }

  public getConsumptionMaterialWashingList(filters: QueryFilter) {
    return this.httpClient.execWithResponseMeta<any[]>(`${Models.ConsumptionMaterialWashing.ApiUrl}/list${filters.asQueryString}`, {
      method: 'GET',
    });
  }

  public async checkDuplicate(data: Models.CheckDuplicateConsumptionMaterialWashing) {
    return await this.httpClient.exec<{ IsDuplicate: boolean }>(`${Models.ConsumptionMaterialWashing.ApiUrl}/checkDuplicate`, {
      method: 'POST',
      body: JSON.stringify(data),
    });
  }
}
